// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"67fb3eb5","455":"eebe22c0","977":"d3f78574"}[chunkId] + ".chunk.js";
};